// extracted by mini-css-extract-plugin
export default {"root":"src-views-editor-components-PollScreensPanel-PollScreensPanel__root--lhWoN"};